var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.roleRules.FEES_FLG === "Y"
        ? [
            _vm.roleRules.FEES_DESCRIPTION_FLG === "Y" &&
            _vm.headerText.length > 0
              ? _c("div", {
                  staticClass: "instructions alert alert-info",
                  domProps: { innerHTML: _vm._s(_vm.headerText) }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.district.CWP_ALLOW_PAYMENTS_FLG == "N"
              ? _c("h2", { attrs: { tabindex: "0" } }, [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(
                        _vm.$t("MAIN_CONTENT.Fees.balanceOwed", { fee: "" })
                      ) +
                      " "
                  ),
                  _c(
                    "span",
                    { class: { "text-danger": _vm.totalBalanceOwed > 0 } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$options.filters.dollar(_vm.totalBalanceOwed)
                        )
                      )
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.district.CWP_ALLOW_PAYMENTS_FLG == "Y"
              ? _c("payment-portal", {
                  attrs: { balance: _vm.totalBalanceOwed },
                  on: {
                    paid: function($event) {
                      return _vm.loadFees()
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.district.CWP_ALLOW_PAYMENTS_FLG == "N"
              ? _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-xs-12" },
                    [
                      _c("sapphire-toggle", {
                        staticClass: "col-xs-6 col-md-4 col-lg-3",
                        attrs: {
                          label: _vm.$t("MAIN_CONTENT.Fees.showAllSchoolYears"),
                          ariaLabel: _vm.$t(
                            "MAIN_CONTENT.Fees.showAllSchoolYears"
                          )
                        },
                        model: {
                          value: _vm.useAllSchoolYears,
                          callback: function($$v) {
                            _vm.useAllSchoolYears = $$v
                          },
                          expression: "useAllSchoolYears"
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.feesData.length > 0 &&
            _vm.district.CWP_ALLOW_PAYMENTS_FLG == "N"
              ? _c(
                  "div",
                  { staticClass: "table-responsive" },
                  [
                    _c(
                      "table-editable-list",
                      {
                        attrs: {
                          columns: _vm.columns,
                          "show-select": false,
                          "show-actions": false,
                          headerClasses: "text-left"
                        }
                      },
                      [
                        _c(
                          "template",
                          { slot: "data-row" },
                          [
                            _vm._l(_vm.feesData, function(fee, feeIdx) {
                              return [
                                _c("table-list-row", {
                                  key: "fee-" + fee.TRANS_ID,
                                  attrs: {
                                    columns: _vm.columns,
                                    rowdata: fee,
                                    rowIndex: feeIdx,
                                    showActions: false
                                  }
                                })
                              ]
                            })
                          ],
                          2
                        )
                      ],
                      2
                    )
                  ],
                  1
                )
              : _vm._e()
          ]
        : [
            _vm._v(
              "\n\t\t" +
                _vm._s(
                  _vm.$t("MAIN_CONTENT.commonContent.invalidPermissions")
                ) +
                "\n\t"
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }